import {windowedFiniteBatchScheduler} from "@yornaath/batshit";
import {HTTPError} from "platformed-client";
import {Nominal} from "platformed-client/types";

type ExtractIdPropertyNames<T> = {
  [K in keyof T]: T[K] extends Nominal<string, string> ? K : never;
}[keyof T];

export function resolver<
  T extends Array<any>,
  const K extends ExtractIdPropertyNames<R>,
  R = T extends Array<infer A> ? Exclude<A, null> : never,
>(key: K) {
  return (items: T, query: R[K]): R => {
    const result = items.find(item => item != null && item[key] == query);
    if (result == null) {
      throw new HTTPError(new Response(null, {status: 404}));
    }
    return result;
  };
}

export function resolverFn<
  const F extends (item: any, query: any) => boolean,
  A = Parameters<F>[0],
  Q = Parameters<F>[1],
>(f: F) {
  return (items: (A | null | undefined)[], query: Q): A => {
    const result = items.find(item => item != null && f(item, query));
    if (result == null) {
      throw new HTTPError(new Response(null, {status: 404}));
    }
    return result;
  };
}

export const scheduler = windowedFiniteBatchScheduler({windowMs: 100, maxBatchSize: 100});
